var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThreeDotsIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2.882,
    height: 14,
    viewBox: "0 0 2.882 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "overflow-menu-vertical",
    transform: "translate(-15.75 -6.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M18.632,8.191A1.441,1.441,0,1,1,17.191,6.75,1.441,1.441,0,0,1,18.632,8.191Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M18.632,17.191a1.441,1.441,0,1,1-1.441-1.441A1.441,1.441,0,0,1,18.632,17.191Z",
    transform: "translate(0 -3.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M18.632,26.191a1.441,1.441,0,1,1-1.441-1.441A1.441,1.441,0,0,1,18.632,26.191Z",
    transform: "translate(0 -6.882)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThreeDotsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/three_dots_icon.da5aa92e0f3f6c021fa3445e60ca0beb.svg";